var _rect, _rect2, _rect3, _rect4, _rect5, _circle, _rect6, _rect7;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMakeClaimThin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 45,
    height: 45,
    viewBox: "0 0 45 45",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 5.5,
    y: 4.5,
    width: 34,
    height: 39,
    rx: 0.5,
    stroke: "#323232"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 8.5,
    y: 8.5,
    width: 28,
    height: 32,
    stroke: "#323232"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 16.5,
    y: 4.5,
    width: 12,
    height: 6,
    fill: "white",
    stroke: "#323232"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 14.5,
    y: 15.5,
    width: 16,
    height: 5,
    stroke: "#323232"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 14.25,
    y: 24.25,
    width: 16.5,
    height: 0.5,
    stroke: "#323232",
    strokeWidth: 0.5
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 22.5,
    cy: 3.5,
    r: 2,
    fill: "white",
    stroke: "#323232"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 14.25,
    y: 28.25,
    width: 16.5,
    height: 0.5,
    stroke: "#323232",
    strokeWidth: 0.5
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 14.25,
    y: 32.25,
    width: 12.5,
    height: 0.5,
    stroke: "#323232",
    strokeWidth: 0.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMakeClaimThin);
export default __webpack_public_path__ + "static/media/makeClaimThin.77aa205a31309720571dd98b55aea582.svg";
export { ForwardRef as ReactComponent };